export default "/images/0db10988da312c76ba3bb37a6b1e0173.avif";